import { render, staticRenderFns } from "./ContactRelationshipOverlay.vue?vue&type=template&id=48bbbd00"
import script from "./ContactRelationshipOverlay.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports